import { FC } from 'react';
import { match } from 'ts-pattern';

import { ScrollableList } from '@/shared/components/ScrollableList';
import { MockLot } from '@/shared/stubs/lot';

import { ImageItem } from './ImageItem';
import { LotCardItem } from './LotCardItem/LotCardItem';
import styles from './Row.module.scss';
import { TextItem } from './TextItem';
import { ItemLot, LotInput, LotItem } from './types';

interface Props {
  lotIds?: LotInput[];
  lots?: LotItem[];
  locale: string;
  previewOnly?: boolean;
}

export const Row: FC<Props> = ({
  locale,
  lotIds = [],
  lots = [],
  previewOnly = false,
}) => {
  const items = match({
    hasIds: lotIds.length > 0,
    hasItems: lots.length > 0,
  })
    .with({ hasIds: true, hasItems: false }, () =>
      lotIds.map((item) => {
        switch (item.type) {
          case 'lot':
            return {
              ...MockLot({ locale, id: item.lotId }),
              type: 'lot',
            } as ItemLot;
          default:
            return item;
        }
      })
    )
    .otherwise(() => lots);
  const itemsMappedToType = items
    .map((lot, index) => {
      const idx = index;
      switch (lot.type) {
        case 'lot':
          return (
            <LotCardItem key={lot.id} lot={lot} previewOnly={previewOnly} />
          );
        case 'text':
          return <TextItem locale={locale} key={idx} item={lot} />;
        case 'image':
          return <ImageItem locale={locale} key={idx} item={lot} />;
        default:
          return null;
      }
    })
    .filter((item) => item);

  return (
    <ScrollableList itemClassName={styles.item} arrowClassName={styles.arrow}>
      {itemsMappedToType}
    </ScrollableList>
  );
};
